import $ from 'jquery';
window.$ = window.jQuery = $;
import AOS from 'aos';
import "jquery-match-height/jquery.matchHeight";
import SmoothScroll from "smooth-scroll/dist/smooth-scroll.min.js";


// import "@fortawesome/fontawesome-free/js/fontawesome.min";
// import "@fortawesome/fontawesome-free/js/solid.min";
// import "@fortawesome/fontawesome-free/js/regular.min";
// import "@fortawesome/fontawesome-free/js/brands.min";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css"; // ✅ Correct path for Fancybox CSS

import { animations } from "./animations";
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import Packery from 'packery'; // must be imported before isotope

import Isotope from 'isotope-layout';
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';



/****************************************************************************
 * Theme scripts.
 ****************************************************************************/


window.addEventListener('load', function () {
    AOS.refresh();
});

window.onload = function () {
    document.body.classList.add('is-ready');
};



(function ($) {

    // let $grid;
    //
    // $(document).on('facetwp-loaded', function () {
    //     const $container = jQuery('.grid');
    //
    //     if ($container.length) {
    //         if ($grid) {
    //             $grid.isotope('destroy');
    //         }
    //
    //         $grid = new Isotope($container[0], {
    //             itemSelector: '.grid-item',
    //             layoutMode: 'packery',
    //             packery: {
    //                 gutter: 40
    //             }
    //         });
    //     }
    // });



    $(document).ready(function () {
        if (typeof AOS !== 'undefined') {
            AOS.init({ duration: 1500, once: true, startEvent: 'load' });

            setTimeout(() => {
                AOS.refresh();
            }, 2000);

            $(window).on('scroll', function () {
                AOS.refresh();
            });
        } else {
            console.error("AOS is not defined. Make sure the AOS library is loaded.");
        }

        // All animations will take exactly 500ms
        var scroll = new SmoothScroll('a[href*="#"]', {
            speed: 500,
            speedAsDuration: true,
            offset: 100,
        });

        // Smooth scroll if there is a hash on page load
        if (window.location.hash) {
            var hash = window.location.hash;
            var targetElement = document.querySelector(hash);

            if (targetElement) {
                scroll.animateScroll(targetElement, null, {
                    speed: 500,
                    speedAsDuration: true,
                    offset: 100,
                });
            }
        }

        $(".faq-block-item a").click(function (e) {
            e.preventDefault(); // Prevent default anchor behavior

            var $content = $(this).next(".faq-block-content");
            var $icon = $(this).find("svg .line");

            $(".faq-block-content").not($content).slideUp(); // Close other open items
            $(".faq-block-item a svg .line").not($icon).css("display", "block"); // Reset plus icon

            if ($content.is(":visible")) {
                $content.slideUp();
                $icon.css("display", "block"); // Keep the plus sign
            } else {
                $content.slideDown();
                $icon.css("display", "none"); // Hide vertical line to show minus sign
            }
        });


        var animating = false;
        var hideTimeout = null;

        function bindEvents() {
            $(".title-wrapper").off("mouseenter mouseleave click");

            if ($(window).width() > 1023) {
                // Desktop: hover
                $(".title-wrapper").hover(
                    function () {
                        if (animating) return;

                        // Cancel any pending hide
                        clearTimeout(hideTimeout);

                        animating = true;
                        var $this = $(this);
                        var roomType = $this.data("type");

                        $(".title-wrapper .content-outer:visible").stop(true, true).slideUp(300);
                        $this.find(".content-outer").stop(true, true).slideDown(300, function () {
                            animating = false;
                        });

                        $(".image").removeClass("active-image");
                        $('.image[data-image="' + roomType + '"]').addClass("active-image");
                    },
                    function () {
                        // Add delay before hiding to prevent flicker
                        hideTimeout = setTimeout(function () {
                            $(".title-wrapper .content-outer").stop(true, true).slideUp(300);
                            $(".image").removeClass("active-image");
                            animating = false;
                        }, 200); // 200ms delay — tweak as needed
                    }
                );
            } else {
                // Mobile: click
                $(".title-wrapper").on("click", function () {
                    if (animating) return;

                    animating = true;
                    var $this = $(this);
                    var roomType = $this.data("type");

                    $(".title-wrapper").removeClass('active');
                    $this.toggleClass('active');

                    $(".title-wrapper .content-outer:visible").not($this.find(".content-outer")).slideUp(300);
                    $this.find(".content-outer").stop(true, true).slideToggle(300, function () {
                        animating = false;
                    });

                    $(".image").removeClass("active-image");
                    $('.image[data-image="' + roomType + '"]').addClass("active-image");
                });
            }
        }

        jQuery(document).ready(function ($) {
            $('.js-view-amenities').on('click', function (e) {
                e.preventDefault();

                const $btn = $(this);
                const $list = $btn.prev('.amenities-list');
                const $items = $list.find('.amenity-hidden');

                if ($btn.hasClass('active')) {
                    // Hide with stagger
                    $items.get().reverse().forEach((el, i) => {
                        setTimeout(() => {
                            $(el).fadeOut(150).addClass('hidden');
                        }, i * 50); // reverse stagger
                    });

                    $btn.removeClass('active').text('View all amenities +');
                } else {
                    // Show with stagger
                    $items.each(function (i) {
                        const $item = $(this);
                        setTimeout(() => {
                            $item.removeClass('hidden').hide().fadeIn(200);
                        }, i * 50); // stagger delay
                    });

                    $btn.addClass('active').text('Hide all amenities –');
                }
            });
        });


        // Bind on load
        $(document).ready(function () {
            bindEvents();
        });

        // Re-bind on resize
        $(window).on("resize", function () {
            bindEvents();
        });



        if ($('.js-offers-swiper')[0]) {
            var offersSwiper = new Swiper(".js-offers-swiper", {
                loop: false, // Enables infinite looping
                slidesPerView: 1.1, // Default: Show 1 slide at a time
                spaceBetween: 40, // Space between slides
                // autoplay: {
                //     delay: 5000, // Auto-slide every 5 seconds
                //     disableOnInteraction: false // Keeps autoplay running after interaction
                // },
                navigation: {
                    nextEl: ".js-offers-swiper .swiper-button-next",
                    prevEl: ".js-offers-swiper .swiper-button-prev",
                },
                scrollbar: {
                    el: ".js-offers-swiper .swiper-scrollbar",
                    hide: false, // Keeps scrollbar visible
                    draggable: true, // Allows dragging the scrollbar
                },
                breakpoints: {
                    768: { slidesPerView: 2 }, // Show 2 slides from 768px+
                    1024: { slidesPerView: 3.7 }, // Show 3 slides from 1024px+
                }
            });
        }

        if ($('.js-posts-swiper')[0]) {
            var offersSwiper = new Swiper(".js-posts-swiper", {
                loop: false, // Enables infinite looping
                slidesPerView: 1.1, // Default: Show 1 slide at a time
                spaceBetween: 40, // Space between slides
                // autoplay: {
                //     delay: 5000, // Auto-slide every 5 seconds
                //     disableOnInteraction: false // Keeps autoplay running after interaction
                // },
                navigation: {
                    nextEl: ".js-posts-swiper .swiper-button-next",
                    prevEl: ".js-posts-swiper .swiper-button-prev",
                },
                scrollbar: {
                    el: ".js-posts-swiper .swiper-scrollbar",
                    hide: false, // Keeps scrollbar visible
                    draggable: true, // Allows dragging the scrollbar
                },
                breakpoints: {
                    768: { slidesPerView: 2 }, // Show 2 slides from 768px+
                    1024: { slidesPerView: 3.2 }, // Show 3 slides from 1024px+
                }
            });
        }

        if ($('.js-gallery-swiper')[0]) {
            var gallerySwiper = new Swiper(".js-gallery-swiper", {
                loop: false, // Enables infinite looping
                slidesPerView: 'auto',
                spaceBetween: 40, // Space between slides
                freeMode: true,
                navigation: {
                    nextEl: ".js-gallery-swiper .swiper-button-next",
                    prevEl: ".js-gallery-swiper .swiper-button-prev",
                },
                scrollbar: {
                    el: ".js-gallery-swiper .swiper-scrollbar",
                    hide: false, // Keeps scrollbar visible
                    draggable: true, // Allows dragging the scrollbar
                },
                // breakpoints: {
                //     768: { slidesPerView: 2 }, // Show 2 slides from 768px+
                //     1024: { slidesPerView: 2 }, // Show 3 slides from 1024px+
                // }
            });

            console.log(gallerySwiper);
        }

        if ($('.js-review-swiper')[0]) {
            var reviewSwiper = new Swiper(".js-review-swiper", {
                loop: false, // Enables infinite looping
                slidesPerView: 1.1, // Default: Show 1 slide at a time
                spaceBetween: 40, // Space between slides
                // autoplay: {
                //     delay: 5000, // Auto-slide every 5 seconds
                //     disableOnInteraction: false // Keeps autoplay running after interaction
                // },
                allowTouchMove: false,
                preventClicksPropagation: false, // Ensures clicks on links inside slides still work
                preventClicks: true, // Stops accidental slide movement on clicks

                navigation: {
                    nextEl: ".js-review-swiper .swiper-button-next",
                    prevEl: ".js-review-swiper .swiper-button-prev",
                },
                scrollbar: {
                    el: ".js-review-swiper .swiper-scrollbar",
                    hide: false, // Keeps scrollbar visible
                    draggable: true, // Allows dragging the scrollbar
                },
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 640px
                    1024: {
                        slidesPerView: 2.8, // Default: Show 1 slide at a time
                    }
                }
            });
        }

        if ($('.js-sidebar-swiper')[0]) {
            var offersSidebar = new Swiper(".js-sidebar-swiper", {
                loop: false, // Enables infinite looping
                slidesPerView: 1, // Default: Show 1 slide at a time
                spaceBetween: 40, // Space between slides
                autoplay: {
                    delay: 5000, // Auto-slide every 5 seconds
                    disableOnInteraction: false // Keeps autoplay running after interaction
                },
                preventClicksPropagation: false, // Ensures clicks on links inside slides still work
                preventClicks: true, // Stops accidental slide movement on clicks
                pagination: {
                    el: ".swiper-pagination-wrapper",
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<div class="' + className + ' swiper-pagination-tab" data-index="' + index + '"><div class="progress-bar"></div></div>';
                    }
                },

            });


            $(".swiper-pause").click(function () {
                if (offersSidebar.autoplay.running) {
                    offersSidebar.autoplay.stop();
                    $(".swiper-pagination-tab .progress-bar").css("animation-play-state", "paused");
                    $(this).html('<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                        '  <mask id="mask0_play" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">\n' +
                        '    <rect width="20" height="20" fill="#D9D9D9"/>\n' +
                        '  </mask>\n' +
                        '  <g mask="url(#mask0_play)">\n' +
                        '    <path d="M7.25 5.25C7.25 4.91667 7.4125 4.75 7.7375 4.75C7.9 4.75 8.05 4.8 8.1875 4.9L14.0125 9.15C14.1667 9.25 14.25 9.41667 14.25 9.625C14.25 9.83333 14.1667 10 14.0125 10.1L8.1875 14.35C8.05 14.45 7.9 14.5 7.7375 14.5C7.4125 14.5 7.25 14.3333 7.25 14V5.25Z" fill="#41433b"/>\n' +
                        '  </g>\n' +
                        '</svg>\n');
                } else {
                    offersSidebar.autoplay.start();
                    $(".swiper-pagination-tab .progress-bar").css("animation-play-state", "running");
                    $(this).html('<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                        '<mask id="mask0_4381_527" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">\n' +
                        '<rect width="20" height="20" fill="#D9D9D9"/>\n' +
                        '</mask>\n' +
                        '<g mask="url(#mask0_4381_527)">\n' +
                        '<path d="M13.25 15.25C12.8375 15.25 12.4844 15.1031 12.1906 14.8094C11.8969 14.5156 11.75 14.1625 11.75 13.75V6.25C11.75 5.8375 11.8969 5.48438 12.1906 5.19063C12.4844 4.89688 12.8375 4.75 13.25 4.75H13.75C14.1625 4.75 14.5156 4.89688 14.8094 5.19063C15.1031 5.48438 15.25 5.8375 15.25 6.25V13.75C15.25 14.1625 15.1031 14.5156 14.8094 14.8094C14.5156 15.1031 14.1625 15.25 13.75 15.25H13.25ZM6.25 15.25C5.8375 15.25 5.48437 15.1031 5.19062 14.8094C4.89687 14.5156 4.75 14.1625 4.75 13.75V6.25C4.75 5.8375 4.89687 5.48438 5.19062 5.19063C5.48437 4.89688 5.8375 4.75 6.25 4.75H6.75C7.1625 4.75 7.51563 4.89688 7.80938 5.19063C8.10313 5.48438 8.25 5.8375 8.25 6.25V13.75C8.25 14.1625 8.10313 14.5156 7.80938 14.8094C7.51563 15.1031 7.1625 15.25 6.75 15.25H6.25Z" fill="#41433b"/>\n' +
                        '</g>\n' +
                        '</svg>\n');
                }
            });

            // Close Button
            $(".swiper-close").click(function () {
                $(".offers-wrapper").removeClass('active');
            });

            // Click on Pagination Tab to Change Slide
            $(".swiper-pagination-tab").click(function () {
                var index = $(this).data("index");
                offersSidebar.slideTo(index);
            });

        }

        if ($('.js-full-width-swiper')[0]) {
            var offersSwiper = new Swiper(".js-full-width-swiper", {
                loop: false, // Enables infinite looping
                slidesPerView: 1, // Default: Show 1 slide at a time
                spaceBetween: 0, // Space between slides
                // autoplay: {
                //     delay: 5000, // Auto-slide every 5 seconds
                //     disableOnInteraction: false // Keeps autoplay running after interaction
                // },
                navigation: {
                    nextEl: ".js-full-width-swiper .swiper-button-next",
                    prevEl: ".js-full-width-swiper .swiper-button-prev",
                },
            });
        }

        if ($('.js-room-swiper')[0]) {
            var roomswiper = new Swiper(".js-room-swiper", {
                loop: false, // Enables infinite looping
                slidesPerView: 1, // Default: Show 1 slide at a time
                spaceBetween: 0, // Space between slides
                preventClicks: false,
                preventClicksPropagation: false,
                navigation: {
                    nextEl: ".js-room-swiper .swiper-button-next",
                    prevEl: ".js-room-swiper .swiper-button-prev",
                },
            });
        }

        if ($('.js-single-rooms-swiper')[0]) {
            var singleRoomsSwiper = new Swiper(".js-single-rooms-swiper", {
                loop: false, // Enables infinite looping
                slidesPerView: 1.1, // Default: Show 1 slide at a time
                spaceBetween: 40, // Space between slides
                slideToClickedSlide: false, // Prevent skipping when clicking
                watchSlidesProgress: true, // Helps maintain proper slide positions
                navigation: {
                    nextEl: ".js-single-rooms-swiper .parent-buttons.swiper-button-next",
                    prevEl: ".js-single-rooms-swiper .parent-buttons.swiper-button-prev",
                },
                scrollbar: {
                    el: ".js-single-rooms-swiper .swiper-scrollbar",
                    hide: false, // Keeps scrollbar visible
                    draggable: true, // Allows dragging the scrollbar
                },
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 640px
                    1024: {
                        slidesPerView: 2.2, // Default: Show 1 slide at a time
                    }
                }
            });
        }

        $(".js-single-room-swiper").each(function () {
            var $this = $(this);
            var postId = $this.data("id"); // Get the unique post ID

            new Swiper($this[0], {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0,
                nested: true, // Allow nested swipers
                preventClicksPropagation: false, // Ensures clicks on links inside slides still work
                preventClicks: false, // Stops accidental slide movement on clicks
                slideToClickedSlide: false, // ✅ Stops slide skipping
                watchSlidesProgress: true, // ✅ Prevents slide misalignment
                navigation: {
                    nextEl: '[data-id="' + postId + '"] .swiper-button-next',
                    prevEl: '[data-id="' + postId + '"] .swiper-button-prev',
                },
            });
            // ✅ Prevent parent Swiper from moving when interacting with child Swiper
            $this.on("mouseenter touchstart", function () {
                singleRoomsSwiper.allowTouchMove = false;
            });
            $this.on("mouseleave touchend", function () {
                singleRoomsSwiper.allowTouchMove = true;
            });

            // ✅ Prevent touch gestures from affecting the parent Swiper
            $this.find(".swiper-slide").on("touchmove", function (e) {
                e.stopPropagation();
            });
        });

        $(".js-logo-swiper").each(function () {
            var $this = $(this);
            var postId = $this.data("id"); // Get the unique post ID

            new Swiper($this[0], {
                loop: false,
                slidesPerView: 2,
                spaceBetween: 40,
                preventClicksPropagation: false, // Ensures clicks on links inside slides still work
                preventClicks: false, // Stops accidental slide movement on clicks
                slideToClickedSlide: false, // ✅ Stops slide skipping
                watchSlidesProgress: true, // ✅ Prevents slide misalignment
                navigation: {
                    nextEl: '[data-id="' + postId + '"] .swiper-button-next',
                    prevEl: '[data-id="' + postId + '"] .swiper-button-prev',
                },
                scrollbar: {
                    el: '[data-id="' + postId + '"] .swiper-scrollbar',
                    hide: false, // Keeps scrollbar visible
                    draggable: true, // Allows dragging the scrollbar
                },
                breakpoints: {
                    768: { slidesPerView: 'auto' }, // Show 2 slides from 768px+
                }
            });
        });

        $('.filter-inner-trigger').on('click', function () {
            $('body').toggleClass('popup-open');
            $('.event-filters').removeClass('hidden-mobile');
            // $('header').css({'translateY':'-100%'});
            $('.js-offers-tab').hide();
        })

        $('.js-close-filter').on('click', function () {
            $('.event-filters').addClass('hidden-mobile');
            $('.js-offers-tab').show();
            // $('header').css({'translateY':'0%'});
            $('body').toggleClass('popup-open');
        })

        $('.flatpickr-apply-btn').on('click', function () {
            $('.event-filters').addClass('hidden-mobile');
        })




        jQuery(document).ready(function ($) {
            $('.read-more-toggle').on('click', function (e) {
                e.preventDefault();

                var $this = $(this);
                var $container = $this.closest('.review-container');
                var $content = $container.find('.content');

                if ($content.hasClass('active')) {
                    // Collapse
                    $content.removeClass('active').css('max-height', '7ch');
                    $this.html('Read More <span>+</span>');
                } else {
                    // Expand: get actual full height
                    var fullHeight = $content[0].scrollHeight;
                    $content
                        .addClass('active')
                        .css('max-height', fullHeight + 'px');

                    $this.html('Read Less <span>-</span>');
                }
            });
        });


        $('.mega-menu .links li').each(function () {
            var $li = $(this);
            var $menu = $li.closest('.mega-menu');
            var $image = $menu.find('.image img');
            var originalSrc = $image.attr('src');

            $li.on('mouseenter', function () {
                var newImage = $(this).data('image');

                if (newImage) {
                    $image.attr('src', newImage);
                }
            });

            $li.on('mouseleave', function () {
                $image.attr('src', originalSrc);
            });
        });

        $('.js-offers-tab').on('click', function (e) {
            e.preventDefault();
            $('.js-offers-wrapper').addClass('active');
        })


        $(".ginput_container input").each(function () {
            var $input = $(this);
            var $label = $input.closest(".gfield").find(".gfield_label");

            function toggleLabel() {
                if ($input.val().trim() !== "") {
                    $label.addClass("float");
                } else {
                    $label.removeClass("float");
                }
            }

            // Run on page load (handles pre-filled fields)
            toggleLabel();

            // Attach event listeners
            $input.on("input focus blur", toggleLabel);
        });


        // Apply matchHeight after pagination is rendered
        function applyMatchHeight() {
            $('.event-card h3').matchHeight({ byRow: true });
        }

        // Observe pagination rendering
        const observer = new MutationObserver(applyMatchHeight);
        const grid = document.getElementById('tile-grid');

        if (grid) {
            observer.observe(grid, { childList: true });
        }

        applyMatchHeight();

        const flatpickrInstance = flatpickr("#dates", {
            mode: "range",
            dateFormat: "m-d-Y",
            minDate: "today",
            showMonths: 2,
            onChange: function (selectedDates) {
                if (selectedDates.length === 2) {
                    const [arrivalDate, departureDate] = selectedDates;
                    $("#arrive").val(flatpickr.formatDate(arrivalDate, "m-d-Y"));
                    $("#depart").val(flatpickr.formatDate(departureDate, "m-d-Y"));
                } else {
                    $("#arrive").val("");
                    $("#depart").val("");
                }
            }
        });

        $("#booking-form").on("submit", function (event) {
            event.preventDefault();

            let arrive = $("#arrive").val();
            let depart = $("#depart").val();
            if (!arrive || !depart) {
                alert("Please select both an arrival and departure date.");
                return;
            }

            let adults = $("#adults").val();
            let children = $("#children").val();
            let promo = $("#promo").val();

            let baseURL = "https://be.synxis.com/?";
            let params = new URLSearchParams({
                adult: adults,
                arrive: arrive,
                depart: depart,
                chain: 33335,
                child: children,
                currency: "USD",
                hotel: 48485,
                level: "hotel",
                locale: "en-US",
                productcurrency: "USD",
                rooms: 1
            });

            if (promo.trim() !== "") {
                params.append("promo", promo);
            }

            window.location.href = baseURL + params.toString();
        });

        if (window.innerWidth <= 1023) {
            $('.amenities-block h3').on('click', function (e) {
                e.preventDefault();
                $(this).parent().toggleClass('active');
            });
        }

        $('.js-trigger-zoom').on('click', function (e) {
            e.preventDefault();

            // Find the current active slide inside the swiper
            const $swiper = $(this).closest('.js-room-swiper');
            const swiperInstance = $swiper[0].swiper;
            const currentIndex = swiperInstance.realIndex;

            // Find all images in the swiper with data-fancybox
            const $links = $swiper.find('[data-fancybox="gallery"]');

            // Trigger Fancybox at current index
            Fancybox.show(
                $links.map(function () {
                    return {
                        src: $(this).attr('href'),
                        type: 'image',
                    };
                }).get(),
                {
                    startIndex: currentIndex,
                }
            );
        });

        $('.mobile-menu .menu-item-has-children > a').on('click', function (e) {
            const $parentItem = $(this).parent('.menu-item-has-children');

            // If the submenu is hidden, prevent default to toggle it
            if (!$parentItem.hasClass('active')) {
                e.preventDefault();
                $('.menu-item-has-children').removeClass('active').find('.sub-menu').slideUp();

                $parentItem.addClass('active');
                $parentItem.find('.sub-menu').slideDown();
            } else {
                $('.menu-item-has-children').removeClass('active').find('.sub-menu').slideUp();
            }
            // Otherwise, let the link work as normal (navigate to href)
        });
        let isOpen = false;

        $('.js-mobile-menu-trigger').on('click', function (e) {
            e.preventDefault();

            const $body = $('body');
            const $menu = $('.mobile-menu');
            const $header = $('.masthead');
            const $buttons = $('.masthead .button');

            const menuIsOpen = $menu.hasClass('active');

            // Toggle menu & body classes
            $menu.toggleClass('active');
            $body.toggleClass('menu-open');

            // Update header and buttons based on state
            if (!menuIsOpen) {
                $header.addClass('header-light');
            } else {
                $header.removeClass('header-light');
            }
        });




        $(document).on('click', '.js-trigger-form', function (e) {
            e.preventDefault();
            $('.gform_wrapper, .gform_confirmation_wrapper').slideToggle();
            $(this).toggleClass('active');
        })


        const $multiselect = $('.custom-multiselect');

        if ($multiselect.length) {
            const $trigger = $multiselect.find('.select-trigger');
            const $popup = $multiselect.find('.select-popup');
            const $checkboxes = $popup.find('input[type="checkbox"]');
            const $applyBtn = $popup.find('.apply-selection');
            const $clearBtn = $popup.find('.clear-selection');

            $trigger.on('click', function (e) {
                e.stopPropagation();
                $popup.toggle();
            });

            $(document).on('click', function (e) {
                if (!$(e.target).closest('.custom-multiselect').length) {
                    $popup.hide();
                }
            });

            $applyBtn.on('click', function () {
                const selected = $checkboxes.filter(':checked');
                const labels = [];

                selected.each(function () {
                    const label = $(this).parent().text().trim();
                    labels.push(label);
                });

                $trigger.text(labels.length > 0 ? labels.join(', ') : 'Select 1 or more...');
                $popup.hide();

                const filters = selected.map(function () {
                    return $(this).val(); // assumes checkbox value matches category
                }).get();

                const $listings = $('.event-listing');
                if ($listings.length) {
                    if (filters.length === 0) {
                        $listings.show();
                    } else {
                        $listings.each(function () {
                            const category = $(this).data('category');
                            $(this).toggle(filters.includes(category));
                        });
                    }

                    // ✅ Hide empty .event-day-group blocks
                    $('.event-day-group').each(function () {
                        const visibleListings = $(this).find('.event-listing').filter(':visible');
                        $(this).toggle(visibleListings.length > 0);
                    });

                    // ✅ Hide empty .month-title sections
                    $('.month-title').each(function () {
                        const wrapper = $(this).closest('.event-list-title-wrapper');
                        if (!wrapper.length) return;

                        let $sibling = wrapper.next();
                        const dayGroups = [];

                        while ($sibling.length && !$sibling.hasClass('event-list-title-wrapper')) {
                            if ($sibling.hasClass('event-day-group')) {
                                dayGroups.push($sibling);
                            }
                            $sibling = $sibling.next();
                        }

                        const hasVisible = dayGroups.some(group => $(group).is(':visible'));
                        wrapper.toggle(hasVisible);
                    });
                }

                // ✅ TILE GRID
                if ($('#tile-grid').length) {
                    filterCards(filters, window.selectedDateRange || []);
                }

                // ✅ FULLCALENDAR
                const $calendarEl = $('#calendar');
                const isCalendarVisible = $calendarEl.is(':visible');
                const supportedViews = ['dayGridMonth', 'timeGridWeek', 'listWeek'];

                if (isCalendarVisible && window.calendar && supportedViews.includes(window.calendar.view.type)) {
                    window.calendar.refetchEvents();
                }
            });



            $clearBtn.on('click', function () {
                $checkboxes.prop('checked', false);
                $trigger.text('Select 1 or more...');

                // ✅ TILE GRID
                if ($('#tile-grid').length) {
                    filterCards([], window.selectedDateRange || []);
                }

                // ✅ Reset visibility of .event-day-group blocks
                $('.event-day-group').show();

                // ✅ Reset visibility of .month-title sections
                $('.month-title').each(function () {
                    const wrapper = $(this).closest('.event-list-title-wrapper');
                    if (!wrapper.length) return;

                    wrapper.show();
                });

                // ✅ FULLCALENDAR
                const $calendarEl = $('#calendar');
                const isCalendarVisible = $calendarEl.is(':visible');
                const supportedViews = ['dayGridMonth', 'timeGridWeek', 'listWeek'];

                if (isCalendarVisible && window.calendar && supportedViews.includes(window.calendar.view.type)) {
                    window.calendar.refetchEvents();
                }
            });


        }


        const $calendarEl = $('#calendar');

        if ($calendarEl.length) {
            console.log(window.fcEvents);
            window.calendar = new Calendar($calendarEl[0], {
                plugins: [dayGridPlugin, timeGridPlugin, listPlugin],
                initialView: window.innerWidth < 768 ? 'listWeek' : 'dayGridMonth',
                headerToolbar: {
                    left: '',
                    center: 'title',
                    right: ''
                },
                contentHeight: 'auto',
                events: function (fetchInfo, successCallback, failureCallback) {
                    const selectedFilters = getSelectedFilters();
                    const allEvents = window.fcEvents || [];
                    const [startDate, endDate] = window.selectedDateRange || [];

                    let filtered = allEvents;

                    // ✅ Filter by category
                    if (selectedFilters.length) {
                        filtered = filtered.filter(event => selectedFilters.includes(event.category));
                    }

                    // ✅ Filter by date range
                    if (startDate && endDate) {
                        filtered = filtered.filter(event => {
                            const eventDate = new Date(event.start); // Parse ISO string
                            const start = new Date(startDate);
                            const end = new Date(endDate);

                            // Remove time for accurate day-level comparison
                            start.setHours(0, 0, 0, 0);
                            end.setHours(23, 59, 59, 999);

                            return eventDate >= start && eventDate <= end;
                        });
                    }

                    successCallback(filtered);
                },


                dayCellContent: function (arg) {
                    const date = arg.date;
                    const month = date.toLocaleString('en-GB', { month: 'short' }).toUpperCase();
                    const day = date.getDate();
                    return `${month} ${day}`;
                }
            });

            // Optional: render now or wait until a tab is active etc.
            // window.calendar.render();
        }

    });
})(jQuery);

window.addEventListener('load', function () {
    AOS.refresh();
});

window.addEventListener('resize', () => {
    if (window.calendar) {
        const currentView = window.calendar.view.type;
        const newView = window.innerWidth < 768 ? 'listWeek' : 'dayGridMonth';

        if (currentView !== newView) {
            window.calendar.changeView(newView);
        }
    }
});

document.addEventListener("DOMContentLoaded", function () {
    Fancybox.unbind("[data-fancybox='gallery']"); // Remove existing Fancybox instances
    Fancybox.bind("[data-fancybox='gallery']", {
        Thumbs: {
            autoStart: true,
        },
        Toolbar: {
            display: ["thumbs", "slideshow", "fullscreen", "zoom", "close"],
        },
    });
});
// function reorderGridWithRandomShuffleAndLandscapeBottom() {
//     const grid = document.querySelector('.grid.facetwp-template');
//     if (!grid) return;
//
//     const allItems = Array.from(grid.children);
//
//     // Shuffle
//     const shuffled = [...allItems].sort(() => 0.5 - Math.random());
//
//     // Pick 3 landscape items
//     const finalLandscapes = [];
//     const rest = [];
//
//     shuffled.forEach(item => {
//         if (item.classList.contains('landscape') && finalLandscapes.length < 3) {
//             finalLandscapes.push(item);
//         } else {
//             rest.push(item);
//         }
//     });
//
//     // Reorder DOM (no innerHTML clear)
//     const reordered = [...rest, ...finalLandscapes];
//     reordered.forEach(item => grid.appendChild(item));
// }
//
// window.addEventListener('load', reorderGridWithRandomShuffleAndLandscapeBottom);
// window.addEventListener('resize', reorderGridWithRandomShuffleAndLandscapeBottom);
// document.addEventListener('facetwp-loaded', reorderGridWithRandomShuffleAndLandscapeBottom);






// function initPackeryGrid() {
//     const grid = document.querySelector('.grid');
//
//     if (grid) {
//         new Packery(grid, {
//             itemSelector: '.grid-item',
//             gutter: 40,
//             percentPosition: true
//         });
//     }
// }
//
// // Initial load
// document.addEventListener('DOMContentLoaded', initPackeryGrid);
//
// // FacetWP hook
// document.addEventListener('facetwp-loaded', initPackeryGrid);

function filterCards(filters = [], dateRange = []) {
    const cards = document.querySelectorAll('.event-card');

    cards.forEach(card => {
        const category = card.querySelector('.event-card-image').dataset.category;
        const date = card.querySelector('.event-card-image').dataset.date;
        const dateObj = date ? new Date(date) : null;

        let match = true;

        // Category filter
        if (filters.length && !filters.includes(category)) {
            match = false;
        }

        // Date range filter
        if (dateRange.length === 2 && dateObj) {
            const start = new Date(dateRange[0]);
            const end = new Date(dateRange[1]);
            if (dateObj < start || dateObj > end) {
                match = false;
            }
        }

        // Show or hide the card
        card.style.display = match ? 'block' : 'none';
    });
}


function getSelectedFilters() {
    const filters = [];
    $('.custom-multiselect input[type="checkbox"]:checked').each(function () {
        filters.push($(this).val());
    });
    return filters;
}


document.addEventListener('DOMContentLoaded', () => {
    const grid = document.getElementById('tile-grid');
    if (grid) {

        filterCards(); // or pass in default filter values

    }
});

import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.view-btn');
    const views = document.querySelectorAll('.view-panel');

    if (buttons) {
        buttons.forEach(button => {
            button.addEventListener('click', () => {
                const target = button.dataset.view;

                // Update active button state
                buttons.forEach(btn => btn.classList.remove('active'));
                button.classList.add('active');

                // Show/hide view panels
                views.forEach(view => {
                    view.style.display = view.id === `view-${target}` ? 'block' : 'none';
                });

                // ✅ Clear filters on view switch
                const $checkboxes = $('.custom-multiselect input[type="checkbox"]');
                const $trigger = $('.custom-multiselect .select-trigger');

                $checkboxes.prop('checked', false);
                $trigger.text('Select 1 or more...');

                if (target === 'tiles' && $('#tile-grid').length) {
                    // Re-run filtering logic on already-rendered PHP tiles
                    const filters = getSelectedFilters(); // still empty since checkboxes were just cleared
                    filterCards(filters);
                }

                // ✅ Reset calendar if visible
                if (target === 'calendar' && typeof calendar !== 'undefined') {
                    calendar.refetchEvents();

                    // Render after slight delay for layout
                    setTimeout(() => {
                        calendar.render();
                    }, 10);
                }
            });

        });
    }
});


document.addEventListener("DOMContentLoaded", function () {
    const trigger = document.getElementById("date-range-inline");
    const panel = document.getElementById("date-range-panel");
    const inlineContainer = document.getElementById("date-range-inline");
    const applyBtn = document.getElementById("apply-dates");
    const clearBtn = document.getElementById("clear-dates");

    // Only run if the inline calendar exists on the page
    if (trigger) {
        const isCalMobile = window.innerWidth <= 576;

        const inlinePicker = flatpickr(inlineContainer, {
            mode: "range",
            dateFormat: "m-d-Y",
            inline: window.innerWidth <= 576 ? true : false,
            minDate: "today", // <- disables all past dates
            showMonths: window.innerWidth <= 768 ? 1 : 2,
            closeOnSelect: false,
            locale: Object.assign({}, flatpickr.l10ns.default, {
                firstDayOfWeek: 0,
                weekdays: {
                    shorthand: ["SU", "MO", "TU", "WE", "TH", "FR", "SA"],
                    longhand: [
                        "Sunday", "Monday", "Tuesday",
                        "Wednesday", "Thursday", "Friday", "Saturday"
                    ]
                }
            }),
            onChange: function (selectedDates, dateStr, instance) {
                // Prevent closing after selecting a full range
                if (selectedDates.length === 2) {
                    // Stop Flatpickr from auto-closing
                    instance._hideNext = true;
                }
            },
            onOpen: function (selectedDates, dateStr, instance) {
                if (!isCalMobile) {
                    addShortcutButtons(instance);
                    addFooterButtons(instance);
                }

            }

        });

        // Manually call buttons logic if inline
        if (isCalMobile) {
            addShortcutButtons(inlinePicker);
            addFooterButtons(inlinePicker);
        }

        function addShortcutButtons(instance) {
            // Prevent duplicates
            if (instance.calendarContainer.querySelector(".flatpickr-shortcuts")) return;

            const shortcutContainer = document.createElement("div");
            shortcutContainer.className = "flatpickr-shortcuts";
            shortcutContainer.innerHTML = `
        <button type="button" data-shortcut="today" class="button button--outline" title="Today">Today</button>
        <button type="button" data-shortcut="tomorrow" class="button button--outline" title="Tomorrow">Tomorrow</button>
        <button type="button" data-shortcut="this-week" class="button button--outline" title="This Week">This Week</button>
        <button type="button" data-shortcut="this-month" class="button button--outline" title="This Month">This Month</button>
    `;

            shortcutContainer.addEventListener("click", (e) => {
                if (e.target.tagName === "BUTTON") {
                    const today = new Date();
                    let start, end;

                    switch (e.target.dataset.shortcut) {
                        case "today":
                            start = end = today;
                            break;
                        case "tomorrow":
                            start = end = new Date(today);
                            start.setDate(today.getDate() + 1);
                            break;
                        case "this-week":
                            start = new Date(today);
                            end = new Date(today);
                            const day = today.getDay(); // 0 = Sunday, 6 = Saturday
                            const daysUntilSaturday = 6 - day;
                            end.setDate(today.getDate() + daysUntilSaturday);
                            start.setHours(0, 0, 0, 0);
                            end.setHours(23, 59, 59, 999);
                            break;
                        case "this-month":
                            start = new Date(today); // today
                            end = new Date(today.getFullYear(), today.getMonth() + 1, 0); // last day of this month
                            start.setHours(0, 0, 0, 0);
                            end.setHours(23, 59, 59, 999);
                            break;
                        default:
                            return;
                    }

                    instance.setDate([start, end], true);
                }
            });

            instance.calendarContainer.insertBefore(shortcutContainer, instance.calendarContainer.firstChild);
        }
        function addFooterButtons(instance) {
            // Prevent duplicates
            if (instance.calendarContainer.querySelector(".flatpickr-footer")) return;

            const footer = document.createElement("div");
            footer.className = "flatpickr-footer";
            footer.innerHTML = `
        <button type="button" class="flatpickr-clear-btn button button--outline">Clear</button>
        <button type="button" class="flatpickr-apply-btn button button--blue">Apply</button>
    `;

            // Append at the bottom
            instance.calendarContainer.appendChild(footer);

            footer.querySelector(".flatpickr-clear-btn").addEventListener("click", () => {
                instance.clear();
                instance.close();
                trigger.value = '';
                window.selectedDateRange = null;

                const listView = document.getElementById('view-list');
                if (listView && listView.style.display !== 'none') {
                    document.querySelectorAll('.event-listing').forEach(listing => {
                        listing.style.display = '';
                    });
                }

                const tileView = document.getElementById('view-tiles');
                if (tileView && tileView.style.display !== 'none') {
                    filterCards(filters); // <- filters are from getSelectedFilters()
                }

                const calendarView = document.getElementById('view-calendar');
                if (calendarView && calendarView.style.display !== 'none' && window.calendar) {
                    window.calendar.refetchEvents();
                }
            });



            footer.querySelector(".flatpickr-apply-btn").addEventListener("click", () => {
                const selected = instance.selectedDates;

                if (selected.length === 2) {
                    const startDate = selected[0];
                    const endDate = selected[1];

                    trigger.value = `${startDate.toLocaleDateString("en-GB")} – ${endDate.toLocaleDateString("en-GB")}`;

                    const listView = document.getElementById('view-list');
                    if (listView && listView.style.display !== 'none') {
                        const $listings = document.querySelectorAll('.event-listing');

                        $listings.forEach(listing => {
                            const rawDate = listing.dataset.date;
                            if (!rawDate) {
                                listing.style.display = 'none';
                                return;
                            }

                            const listingDate = new Date(rawDate + 'T00:00:00'); // force it to ISO format

                            // Strip time from selected range for clean day-level matching
                            const start = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
                            const end = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

                            const inRange = listingDate >= start && listingDate <= end;

                            listing.style.display = inRange ? '' : 'none';
                        });

                        // ✅ Hide empty .event-day-group blocks
                        document.querySelectorAll('.event-day-group').forEach(group => {
                            const listings = group.querySelectorAll('.event-listing');
                            const anyVisible = Array.from(listings).some(item => item.style.display !== 'none');
                            group.style.display = anyVisible ? '' : 'none';
                        });

                        // ✅ Hide empty .month-title sections (wrapped in .event-list-title-wrapper)
                        document.querySelectorAll('.month-title').forEach(title => {
                            const wrapper = title.closest('.event-list-title-wrapper');
                            if (!wrapper) return;

                            let sibling = wrapper.nextElementSibling;
                            const groups = [];

                            while (sibling && !sibling.classList.contains('event-list-title-wrapper')) {
                                if (sibling.classList.contains('event-day-group')) {
                                    groups.push(sibling);
                                }
                                sibling = sibling.nextElementSibling;
                            }

                            const hasVisible = groups.some(group => group.style.display !== 'none');
                            wrapper.style.display = hasVisible ? '' : 'none';
                        });

                    }
                    const tileView = document.getElementById('view-tiles');
                    console.log(tileView);
                    window.selectedDateRange = [startDate, endDate]; //

                    if (tileView && tileView.style.display !== 'none') {
                        filterCards(categoryFilters, [startDate, endDate]);

                    }

                    const calendarView = document.getElementById('view-calendar');
                    if (calendarView && calendarView.style.display !== 'none' && window.calendar) {
                        window.calendar.gotoDate(startDate); //
                        window.calendar.refetchEvents(); //
                    }

                }

                instance.close();
            });

        }


    }
});


document.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector('.masthead');
    const button = header?.querySelector('.button--white, .button--brown');
    const $filterToggle = $('.filter-toggle');
    const isMobile = window.innerWidth <= 576;
    const hasFilterToggle = $filterToggle.length > 0;
    const filterTop = hasFilterToggle ? $filterToggle.offset().top : 0;
    const headerHeight = header?.offsetHeight || 0;

    function handleScroll() {
        if (document.body.classList.contains('popup-open')) return;

        const scrollY = window.scrollY;

        // Header color & style toggle
        if (header && button) {
            if (scrollY > headerHeight) {
                header.classList.add('header-light', 'sticky');
                button.classList.remove('button--white');
                button.classList.add('button--brown');
            } else {
                header.classList.remove('header-light', 'sticky');
                button.classList.remove('button--brown');
                button.classList.add('button--white');
            }

            // Only if filter-toggle exists, hide header when scrolling past it
            // if (hasFilterToggle) {
            //     console.log(scrollY + '>' + filterTop);
            //     if (scrollY > filterTop) {
            //         header.style.transform = 'translateY(-100%)';
            //     } else {
            //         header.style.transform = 'translateY(0)';
            //     }
            // }
        }

        // Sticky filter-toggle on mobile
        if (isMobile && hasFilterToggle) {
            if (scrollY >= filterTop) {
                $filterToggle.addClass('is-sticky');
            } else {
                $filterToggle.removeClass('is-sticky');
            }
        }
    }

    window.addEventListener('scroll', handleScroll);
});


document.addEventListener('DOMContentLoaded', function () {
    const megaMenus = document.querySelectorAll('.mega-menu');

    megaMenus.forEach(menu => {
        const targetId = menu.getAttribute('data-menu');
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
            targetElement.appendChild(menu);
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const megaMenus = document.querySelectorAll('.mega-menu');

    megaMenus.forEach(menu => {
        const targetId = menu.getAttribute('data-menu');
        const trigger = document.getElementById(targetId);

        if (trigger) {

            let hideTimeout;

            const showMenu = () => {
                clearTimeout(hideTimeout);
                menu.style.display = 'block';
            };

            const hideMenu = () => {
                hideTimeout = setTimeout(() => {
                    menu.style.display = 'none';
                }, 200); // small delay to allow entering the menu
            };

            trigger.addEventListener('mouseenter', showMenu);
            trigger.addEventListener('mouseleave', hideMenu);

            menu.addEventListener('mouseenter', () => {
                clearTimeout(hideTimeout);
            });

            menu.addEventListener('mouseleave', hideMenu);
        }
    });
});

// document.addEventListener('DOMContentLoaded', function () {
//     if (typeof flatpickr === 'function') {
//         const startInput = document.querySelector('#input_5_8');
//         const endInput = document.querySelector('#input_5_9');
//
//         if (startInput && endInput) {
//             // Remove any Gravity Forms-added icon styling
//             startInput.classList.remove('hasDatepicker');
//             endInput.classList.remove('hasDatepicker');
//
//             // Remove the hidden calendar icon if present
//             document.querySelector('#gforms_calendar_icon_input_5_8')?.remove();
//             document.querySelector('#gforms_calendar_icon_input_5_9')?.remove();
//
//             const config = {
//                 dateFormat: 'm/d/Y',
//                 minDate: 'today',
//                 allowInput: true // allows typing manually too
//             };
//
//             // Initialize END picker first so we can reference it in START
//             const endPicker = flatpickr(endInput, config);
//
//             flatpickr(startInput, {
//                 ...config,
//                 onChange: function (selectedDates) {
//                     if (selectedDates[0]) {
//                         endPicker.set('minDate', selectedDates[0]);
//                     }
//                 }
//             });
//         }
//     }
// });
